module.exports = __webpack_public_path__ + "img/accessory_item_09.8ba4bc02.svg";